import React, { useEffect, useState } from 'react';
import { MDBRadio, MDBSelect, MDBSideNavCollapse, MDBSideNavItem, MDBSideNavLink, MDBSpinner } from 'mdb-react-ui-kit';
import axios from 'axios';


const Session = ({ sessionId, setSessionId, setOffset, setLegislatureId, sessionInfoForHeader, setSessionInfoForHeader }) => {
    const [collapse, setCollapse] = useState(false);
    const [filteredSessionHolder, setFilteredSessionHolder] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [lawsSession, setLawsSession] = useState([]);
    const [controller, setController] = useState(null);

    const naturalCompare = (a, b) => {
        const ax = [], bx = [];

        a.replace(/(\d+)|(\D+)/g, function(_, $1, $2) { ax.push([$1 || Infinity, $2 || ""]) });
        b.replace(/(\d+)|(\D+)/g, function(_, $1, $2) { bx.push([$1 || Infinity, $2 || ""]) });

        while(ax.length && bx.length) {
            const an = ax.shift();
            const bn = bx.shift();
            const nn = (an[0] - bn[0]) || an[1].localeCompare(bn[1]);
            if(nn) return nn;
        }

        return ax.length - bx.length;
    };

    const fetchSessions = async () => {
        if (controller) {
            controller.abort();
        }

        // Create a new AbortController
        const newController = new AbortController();
        setController(newController);

        try {

            setIsLoading(true);
            const [archiveResponse, lawsResponse] = await Promise.all([
                axios.get(`${process.env.REACT_APP_LAWS_ARCHIVE_BACKEND_HOST}/v1/sessions`, {
                    signal: newController.signal
                }),
                axios.get(`${process.env.REACT_APP_LAWS_BACKEND_HOST}/legislators/v1/sessions`, {
                    signal: newController.signal
                })
            ]);

            const archiveSessions = createSelectDataStructureOfLawsArchiveSession(archiveResponse.data);
            const lawsSessions = createSelectDataStructureOfLawsSession(lawsResponse.data);

            // Change the order here to prioritize archiveSessions
            const combinedSessions = [...archiveSessions, ...lawsSessions];
            const uniqueSessions = removeDuplicates(combinedSessions);

            const dataSortedNaturally = uniqueSessions.sort((a, b) => naturalCompare(a.text, b.text));
            const dataSortedInDescendingOrder = dataSortedNaturally.reverse();

            setFilteredSessionHolder(dataSortedInDescendingOrder);
            setIsLoading(false);
        } catch (error) {
            if (axios.isCancel(error)) {
                console.log('Request canceled', error.message);
            } else {
                console.error('Error fetching data: ', error);
            }
        } finally {
            setIsLoading(false);
        }
    };

    const createSelectDataStructureOfLawsArchiveSession = (sessions) => {
        return sessions.map((item) => ({
            text: `${item.sessionYear.toString()} (${item.sessionTypeDesc})`,
            value: item.sessionId,
        }));
    };

    const createSelectDataStructureOfLawsSession = (sessions) => {
        return sessions.map(item => {
            if (item.startDate) {
                const year = new Date(item.startDate).getFullYear().toString();
                const type = item.type.charAt(0) + item.type.slice(1).toLowerCase();
                return {
                    text: `${year} (${type})`,
                    value: Number(item.id)
                };
            }
            return null;
        }).filter(Boolean);
    };

    const removeDuplicates = (arr) => {
        const seenValues = new Set();
        return arr.filter(item => item && !seenValues.has(item.text) && seenValues.add(item.text));
    };


    useEffect(() => {
        fetchSessions();

        return () => {
            if (controller) {
                controller.abort();
            }
        };
    }, []);

    useEffect(() => {
        setSessionId(sessionId);
    }, [sessionId, setSessionId]);

    const getLegislatureId = (ordinal) => {
        const foundItem = lawsSession.data.find(item => {return item.ordinals == ordinal});
        return foundItem ? foundItem.id : false;
    };

    const handleSessionChange = (event, value) => {
        setSessionId(value);
        const sessionObj =  filteredSessionHolder.find( item => item.value === value);
        setSessionInfoForHeader(sessionObj.text.toString().replace(/[()]/g, ''));
        setOffset(0);
        setLegislatureId(value);
    };

    return (
        <MDBSideNavItem>
            <MDBSideNavLink className='accordion-button' icon='angle-down' shouldBeExpanded={collapse} onClick={() => setCollapse(!collapse)}>
                Session
            </MDBSideNavLink>
            <MDBSideNavCollapse show={collapse}>
                <li className='p-3'>
                    {isLoading ? <p><MDBSpinner size='sm' role='status' tag='span' className='me-2' /> Loading...</p> :
                        <MDBSelect
                            data={filteredSessionHolder}
                            search
                            id='sessionYearSelect'
                            value={sessionId}
                            onValueChange={(event) => {
                                if (event && event.value !== undefined) {
                                    handleSessionChange(event, event.value);
                                } else {
                                    console.error('Invalid event object:', event);
                                }
                            }}
                        />
                    }
                </li>
            </MDBSideNavCollapse>
        </MDBSideNavItem>
    );
};


export default Session;